import React from 'react';

import { Flex } from 'antd';

import { ErrorNotifsSection } from './ErrorNotifsSection';
import { WebhookUrlsSection } from './WebhookUrlsSection';
import { IPartnerV3 } from '@/features/lp-village/partners/models/partnerV3';

interface IWebhooksSettingsProps {
  partner: IPartnerV3;
}

export const WebhooksSettings = ({ partner }: IWebhooksSettingsProps) => (
  <Flex vertical style={{ padding: '16px 0' }} gap={24}>
    <WebhookUrlsSection partnerId={partner.id} />
    <ErrorNotifsSection partnerId={partner.id} />
  </Flex>
);
